<template>
  <div class="py-4 container-fluid">
    <!-- <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'export-excel/sales-advisor-po?project_number='+search.project_number+'&po_number='+search.po_number+'&customer_name='+search.customer_name['name']+'&end_user_name='+search.end_user_name['name']+'&product_name='+search.product_name+'&main_material='+search.main_material+'&material_category='+search.material_category+'&po_received_date='+search.po_received_date+'&delivery_date='+search.delivery_date+'&currency='+search.currency+'&term_of_payment='+search.term_of_payment+'&vat='+search.vat+'&quotation_number='+search.quotation_number+'&code_regulation='+search.code_regulation+'&type_equipment='+search.type_equipment+'&work_location='+search.work_location+'&plant='+search.plant+'&country_plant='+search.country_plant+'&sales_pic='+search.sales_pic+''" target="_BLANK"><i class="fa fa-download fa-sm"></i> Export</a> -->
    <a class="btn btn-sm btn-danger" style="margin-right: 10px;" :href="apiUrl+'print-pdf/sales-advisor-po?project_number='+search.project_number+'&po_number='+search.po_number+'&customer_name='+search.customer_name['name']+'&end_user_name='+search.end_user_name['name']+'&product_name='+search.product_name+'&main_material='+search.main_material+'&material_category='+search.material_category+'&po_received_date='+search.po_received_date+'&delivery_date='+search.delivery_date+'&currency='+search.currency+'&term_of_payment='+search.term_of_payment+'&vat='+search.vat+'&quotation_number='+search.quotation_number+'&code_regulation='+search.code_regulation+'&type_equipment='+search.type_equipment+'&work_location='+search.work_location+'&plant='+search.plant+'&country_plant='+search.country_plant+'&sales_pic='+search.sales_pic+''" target="_BLANK"><i class="fa fa-file-pdf-o fa-sm"></i> Print PDF</a>
   <!--  <div class="row">
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Total Pending"
          :value="convertRp(totalPending)"
          iconClass="fa fa-newspaper-o"
          iconBackground="bg-gradient-secondary"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Approved"
          :value="convertRp(totalApproved)"
          iconClass="fa fa-check-circle"
          iconBackground="bg-gradient-success"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Not Approved"
          :value="convertRp(totalNotApproved)"
          iconClass="fa fa-times-circle"
          iconBackground="bg-gradient-danger"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="On Duty"
          :value="convertRp(totalOnDuty)"
          iconClass="fa fa-car"
          iconBackground="bg-gradient-warning"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Done"
          :value="convertRp(totalDone)"
          iconClass="ni ni-satisfied"
          iconBackground="bg-gradient-info"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-2 col-md-6 col-12">
        <card
          title="Total Request"
          :value="convertRp(totalRequest)"
          iconClass="fa fa-tasks"
          iconBackground="bg-gradient-primary"
          directionReverse
        ></card>
      </div>
    </div> -->
    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-lg-4">
                <div class="card-header pb-0">
                  <h6>Invoice</h6>
                </div>
              </div>
              <div class="col-lg-4">
              </div>
              <div class="col-lg-4 float-right">
                <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="create()"
                ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table table-striped table-sm table-bordered table-hover align-items-center mb-0">
                  <thead>
                    <tr style="background-color: #F0F8FF;">
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">INVOICE NUMBER</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">INVOICE DATE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">TEF PROJECT NUMBER</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PO NUMBER</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CUSTOMER NAME</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">END USER NAME</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PRODUCT NAME</th>
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">DELIVERY DATE</th> -->
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">QTY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">UNIT PRICE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">TOTAL PRICE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PAYOUT PERCENTAGE</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CURRENCY</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">EXCHANGE RATE</th>
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">TERM OF PAYMENT</th> -->
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">VAT</th>
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">DELAY PENALTY CLAUSE</th> -->
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PLANT</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">COUNTRY PLANT</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">SALES PIC</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Created At</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Created By</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i" @click="setBg(i)" :style="(backgroundRed == i) ? 'background-color: #7FFF00; cursor: pointer;' : 'cursor: pointer;' ">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <router-link :to="{ name: 'InvoiceDetail', params: { invoice_number: row.invoice_number }}">
                          <span class="badge badge-sm bg-gradient-primary">{{ row.invoice_number }}</span>
                        </router-link>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ moment(row.invoice_date).locale('en').format('ll') }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                          <span class="badge badge-sm bg-gradient-info">{{ row.project_number }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.po_number }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.customer_name }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.end_user_name }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.product_name }}</span>
                      </td>
                      <!-- <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ moment(row.delivery_date).locale('en').format('ll') }}</span>
                      </td> -->
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.qty }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ convertRp(row.unit_price) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ convertRp(row.unit_price * row.qty) }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.percentage }} %</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.currency }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ convertRp(row.exchange_rate)}}</span>
                      </td>
                      <!-- <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.term_of_payment }}</span>
                      </td> -->
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.vat }}</span>
                      </td>
                      <!-- <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.delay_penalty_clause }}</span>
                      </td> -->
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.plant }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.country_plant }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.sales_pic }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ moment(row.created_at).locale('en').format('ll') }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.created_by }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <!-- <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="edit(row.id)"></i> -->
                        <i class="fas fa-trash fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-left">TOTAL ROWS : {{table.data.length}} </div>
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD DATA ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{form.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Project Number <span style="color: red;">*</span></label>
        <multiselect v-model="invoiceData.project_number" :options="tablePoList.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Project Number" label="project_number" track-by="project_number" :preselect-first="true" @keyup="getPoList" @select="paymentTerm" :disabled="form.title == 'Edit Data'" :loading="isLoading">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">Term Of Payment <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="invoiceData.term_payment" @change="generateInvoiceNo" :disabled="form.title == 'Edit Data'">
          <option v-for="(row, i) in tablePayTerm.data" :key="i" :value="row.term_payment" >{{row.term_payment}}</option>
        </select>
        <!-- <label for="example-text-input" class="form-control-label mt-3">Invoice Number <span style="color: red;">*</span></label> -->
        <!-- <input type="text" class="form-control" placeholder="Invoice Number" v-model="invoiceData.invoice_number" disabled=""> -->
        <label for="example-text-input" class="form-control-label mt-3">Invoice Date <span style="color: red;">*</span></label>
        <input type="date" class="form-control" placeholder="Invoice Date" v-model="invoiceData.invoice_date">
        
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-lg-6 col-4"> 
        </div>
        <div class="col-lg-2 col-3" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="form.show = true">Close</argon-button>
        </div>
        <div class="col-lg-1 col-2">
        <button type="primary" class="btn btn-sm btn-info btn-fill" @click="save()" :disabled="onLoading">
          <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
          <span v-else>
              <span>Save</span>
          </span>
        </button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">TEF Project Number </label>
        <input type="text" class="form-control" placeholder="TEF Project Number" v-on:keyup.enter="get()" v-model="search.project_number">
        <label for="example-text-input" class="form-control-label mt-3">PO Number </label>
        <input type="text" class="form-control" placeholder="PO Number" v-on:keyup.enter="get()" v-model="search.po_number">
        <label for="example-text-input" class="form-control-label mt-3">Customer </label>
        <multiselect v-on:keyup.enter="get()" v-model="search.customer_name" :options="tableCustomer.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Customer" label="name" track-by="name" :preselect-first="true" @keyup="getCustomer">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">End User Name </label>
        <multiselect v-on:keyup.enter="get()" v-model="search.end_user_name" :options="tableCustomer.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Customer" label="name" track-by="name" :preselect-first="true" @keyup="getCustomer">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">Product Name </label>
        <input type="text" class="form-control" placeholder="Product Name" v-on:keyup.enter="get()" v-model="search.product_name">
        <label for="example-text-input" class="form-control-label mt-3">Main Material </label>
        <input type="text" class="form-control" placeholder="Main Material" v-on:keyup.enter="get()" v-model="search.main_material">
        <label for="example-text-input" class="form-control-label mt-3">Material Category </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.material_category">
          <option value="CS">CS</option>
          <option value="Cu-Ni">Cu-Ni</option>
          <option value="Duplex">Duplex</option>
          <option value="Ni Alloy">Ni Alloy</option>
          <option value="SUS">SUS</option>
          <option value="Ti">Ti</option>
          <option value="Other">Other</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">PO Received Date </label>
        <input type="date" class="form-control" placeholder="PO Received Date" v-on:keyup.enter="get()" v-model="search.po_received_date">
        <label for="example-text-input" class="form-control-label mt-3">Delivery Date </label>
        <input type="date" class="form-control" placeholder="Delivery Date" v-on:keyup.enter="get()" v-model="search.delivery_date">
        <label for="example-text-input" class="form-control-label mt-3">Currency </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.currency">
          <option value="IDR">IDR - Indonesian Rupiah</option>
          <option value="USD">USD - US Dollar</option>
          <option value="KRW">KRW - South Korean Won</option>
          <option value="SGD">SGD - Singapore Dollar</option>
          <option value="JPY">JPY - Japanese Yen</option>
          <option value="EUR">EUR - Euro</option>
          <option value="GBP">GBP - British Pound</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Term Of Payment </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.term_of_payment">
          <option value="DP">DP</option>
          <option value="2nd Payment">2nd Payment</option>
          <option value="3nd Payment">3nd Payment</option>
          <option value="4nd Payment">4nd Payment</option>
          <option value="5nd Payment">5nd Payment</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">VAT (11 %) </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.vat">
          <option value="Include">Include</option>
          <option value="Exclude">Exclude</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Quotation Number </label>
        <input type="text" class="form-control" placeholder="Quotation Number" v-on:keyup.enter="get()" v-model="search.quotation_number">
        <label for="example-text-input" class="form-control-label mt-3">Code/Regulation </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.code_regulation">
          <option value="ASME">ASME</option>
          <option value="HPGSL/Tokutei">HPGSL/Tokutei</option>
          <option value="Ichiatsu">Ichiatsu</option>
          <option value="Niatsu">Niatsu</option>
          <option value="Shobo">Shobo</option>
          <option value="Kemenaker">Kemenaker</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Type Of Equipment / Works </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.type_equipment">
          <option value="V">V - Vessel</option>
          <option value="H">H - Heat Exchanger</option>
          <option value="P">P - Piping</option>
          <option value="M">M - Mufle</option>
          <option value="R">R - Radiant Tube</option>
          <option value="S">S - Service</option>
          <option value="O">O - Other</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Work Location </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.work_location">
          <option value="Workshop">Workshop</option>
          <option value="Site">Site</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Plant </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.plant">
          <option value="Discovery">Discovery</option>
          <option value="Endeavor">Endeavor</option>
          <option value="Simba">Simba</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Country Plant </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.country_plant">
          <option value="Indonesia">Indonesia</option>
          <option value="Japan">Japan</option>
          <option value="Singapore">Singapore</option>
          <option value="Malaysia">Malaysia</option>
          <option value="Thailand">Thailand</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Sales PIC </label>
        <select class="form-select" aria-label="Default select example" v-on:keyup.enter="get()" v-model="search.sales_pic">
          <option value="Agus Setiyono">Agus Setiyono</option>
          <option value="Dwi Febiyanti">Dwi Febiyanti</option>
          <option value="Sutriyono">Sutriyono</option>
          <option value="Imam Febriawan">Imam Febriawan</option>
          <option value="Rahadian Akmal Wildanum">Rahadian Akmal Wildanum</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-lg-6 col-4"> 
        </div>
        <div class="col-lg-2 col-3" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="search = {}">Clear</argon-button>
        </div>
        <div class="col-lg-1 col-2">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

</template>

<script>
// import Card from "@/examples/Cards/Card.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css';
var moment = require('moment');
import salesInvoice from '@/services/salesInvoice.service';
import salesAdvisorPo from '@/services/salesAdvisorPo.service';
import customer from '@/services/customer.service';

export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
    Multiselect,
    BasePagination,
    // Card,
  },
  data() {
    return {
      moment:moment,
      pagination: {
        page_count: '',
        page: 1,
      },
      table: {
        data: []
      },
      tablePayTerm: {
        data: []
      },
      form: {
        add: true,
        title: "Add Data",
        show: false
      },
      formImport: {
        add: true,
        title: "Import Data Setting Approval",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      dataImport: '',
      onLoading: false,
      tabelError: {
        data: []
      },
      storageUrl : config.storageUrl,
      invoiceData: {},
      search: {
        project_number: '',
        po_number: '',
        customer_name: '',
        end_user_name: '',
        product_name: '',
        main_material: '',
        material_category: '',
        po_received_date: '',
        delivery_date: '',
        currency: '',
        term_of_payment: '',
        vat: '',
        quotation_number: '',
        code_regulation: '',
        type_equipment: '',
        work_location: '',
        plant: '',
        country_plant: '',
        sales_pic: '',
      },
      searchMenu: '',
      apiUrl :config.apiUrl,
      isLoading: false,
      tablePlant: {
        data: []
      },
      tablePic: {
        data: []
      },
      tablePoList: {
        data: []
      },
      tableCustomer: {
        data: []
      },
      totalPending: '',
      totalApproved: '',
      totalNotApproved: '',
      totalOnDuty: '',
      totalDone: '',
      totalRequest: '',

      backgroundRed: null,

    };
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    get(param){
      let context = this;               
      Api(context, salesInvoice.index({project_number: this.search.project_number, po_number: this.search.po_number, customer_name: this.search.customer_name['name'], end_user_name: this.search.end_user_name['name'], product_name: this.search.product_name, main_material: this.search.main_material, material_category: this.search.material_category, po_received_date: this.search.po_received_date, delivery_date: this.search.delivery_date, currency: this.search.currency, term_of_payment: this.search.term_of_payment, vat: this.search.vat, quotation_number: this.search.quotation_number, code_regulation: this.search.code_regulation, type_equipment: this.search.type_equipment, work_location: this.search.work_location, plant: this.search.plant, country_plant: this.search.country_plant, sales_pic: this.search.sales_pic, page: context.pagination.page})).onSuccess(function(response) {    
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page
          context.totalPending          = response.data.data.totalPending
          context.totalApproved         = response.data.data.totalApproved
          context.totalNotApproved      = response.data.data.totalNotApproved
          context.totalOnDuty           = response.data.data.totalOnDuty
          context.totalDone             = response.data.data.totalDone
          context.totalRequest          = response.data.data.totalRequest

          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show  = false;
      })
      .call()
    },
    getPoList(param){
      let context = this;        
      context.isLoading = true 
      Api(context, salesAdvisorPo.getPoList({search: param.target.value})).onSuccess(function(response) {    
          context.tablePoList.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tablePoList.data = [];
          }
      }).onFinish(function() { 
        context.isLoading = false
      })
      .call()
    },
    getCustomer(param){
      let context = this;        
      Api(context, customer.getCustomer({search: param.target.value})).onSuccess(function(response) {    
          context.tableCustomer.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableCustomer.data = [];
          }
      }).onFinish(function() { 
      })
      .call()
    },
    paymentTerm() {
      let context = this;               
      Api(context, salesAdvisorPo.showPaymentTerm(context.invoiceData.project_number['project_number'])).onSuccess(function(response) {
        context.tablePayTerm.data  = response.data.data;
      })
      .call()        
    },
    generateInvoiceNo(){
      let context = this;

      if (context.invoiceData.term_payment == 'DP') {
        context.invoiceData.invoice_number = 'MI-'+context.invoiceData.project_number['project_number'] +' Dp';
      }else if(context.invoiceData.term_payment == 'DEL'){
        context.invoiceData.invoice_number = 'MI-'+context.invoiceData.project_number['project_number'] +' Del';
      }else if(context.invoiceData.term_payment == '2nd Payment'){
        context.invoiceData.invoice_number = 'MI-'+context.invoiceData.project_number['project_number'] +' 2nd';
      }else if(context.invoiceData.term_payment == '3rd Payment'){
        context.invoiceData.invoice_number = 'MI-'+context.invoiceData.project_number['project_number'] +' 3rd';
      }else if(context.invoiceData.term_payment == '4th Payment'){
        context.invoiceData.invoice_number = 'MI-'+context.invoiceData.project_number['project_number'] +' 4th';
      }else if(context.invoiceData.term_payment == '5th Payment'){
        context.invoiceData.invoice_number = 'MI-'+context.invoiceData.project_number['project_number'] +' 5th';
      }
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    create() {
      this.form.add    = true;
      this.form.show   = true;
      this.form.title  = "Add Data";
      this.invoiceData = {};
      this.defaultDate()
    },
    edit(id) {
      let context = this;               
      Api(context, salesInvoice.show(id)).onSuccess(function(response) {
        context.invoiceData               = response.data.data.data;
        context.invoiceData.project_number = response.data.data.dataProjectNo[0];
        context.paymentTerm()
        context.invoiceData.term_payment = response.data.data.dataTermPay;
        context.form.show                      = true;
        context.form.title                     = 'Edit Data'; 
      })
      .call()        
    },
    copy(id) {
      let context = this;               
      Api(context, salesInvoice.show(id)).onSuccess(function(response) {
        context.invoiceData               = response.data.data.data;
        context.invoiceData.customer_name = response.data.data.data.dataCustomerName;
        context.invoiceData.end_user_name = response.data.data.data.dataEndUserName;
        context.form.show                 = true;
        context.form.title                = 'Copy Value'; 
      })
      .call()        
    },
    save(){
      let api      = null;
      let context  = this;
      let formData = new FormData();
      context.onLoading = true;

      if (context.invoiceData.project_number != undefined && context.invoiceData.invoice_number != undefined && context.invoiceData.invoice_date != undefined && context.invoiceData.term_payment != undefined) {
        formData.append('project_number', JSON.stringify(context.invoiceData.project_number));
        formData.append('invoice_number', context.invoiceData.invoice_number);
        formData.append('invoice_date', context.invoiceData.invoice_date);
        formData.append('term_payment', context.invoiceData.term_payment);
      }else{
        context.onLoading = false;
        return alert('The Red Star Field is Mandatory')
      }

      if (context.form.title == 'Add Data') {
        api = Api(context, salesInvoice.create(formData));
      } else if(context.form.title == 'Copy Value'){
        api = Api(context, salesInvoice.create(formData));
      }else {
        api = Api(context, salesInvoice.update(this.invoiceData.id, formData));
      }
      api.onSuccess(function(response) {
        context.get();
        context.invoiceData = {}
        context.form.show = false;
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
        context.onLoading = false;
      })
      .call();
    },
    remove(id) {
      let r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context = this;

        Api(context, salesInvoice.delete(id)).onSuccess(function(response) {
            context.get();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    defaultDate(){
      var date  = new Date();
      var day   = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var today = date.getFullYear() + "-" + (month) + "-" + (day);

      this.invoiceData.invoice_date = today
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    convertRp(bilangan) {
      if (bilangan) {
        var number_string = bilangan.toString(),
            sisa    = number_string.length % 3,
            rupiah  = number_string.substr(0, sisa),
            ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        if(ribuan){
          var separator = sisa ? '.' : '';
          rupiah += separator + ribuan.join('.');
          return rupiah
        }else{
          return bilangan
        }
      }
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          autoClose: 2000,
        }); // ToastOptions
      }
    },
    setBg(id) {
      this.backgroundRed = id
    }

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 600px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}

/*for freze ke samping*/
.scroll table td:nth-child(2) {
  position: sticky;
  left: 0;
  background-color: white;
}
</style>
